import { render } from "./NamePage.vue?vue&type=template&id=2426ff51&scoped=true"
import script from "./NamePage.vue?vue&type=script&lang=js"
export * from "./NamePage.vue?vue&type=script&lang=js"

import "./NamePage.vue?vue&type=style&index=0&id=2426ff51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2426ff51"]])

export default __exports__